<template>
<div>
  <a-table
    :columns="columns"
    :data-source="tableData"
    rowKey="id"
    :pagination="false">
    <template v-slot:taskType="{ text }">
      {{ getTaskName(text) }}
    </template>
    <template v-slot:userId="{ text }">
      {{ getUserName(text) }}
    </template>
    <template v-slot:pgress="{ text }">
      {{ getValue(text) }}
    </template>
    <template v-slot:stateName="{ text }">
      {{ getSubStateName(text) }}
    </template>
    <template v-slot:time="{ text }">
      {{ getDateTime(text) }}
    </template>
    <template v-slot:finishTime="{ text }">
      {{ getDateTime(text) }}
    </template>
    <template v-slot:action="{ record, index }">
        <span class="gap-btn">
          <a @click="toDetail(record, index)">详情</a>
        </span>
     <!-- <span class="gap-btn">
          <a @click="handleAllocate(record)">分配</a>
        </span>-->
      <span class="gap-btn" v-if="record.state === 'origin'">
          <a @click="handleAllocate(record, index)">分配</a>
        </span>
      <span class="gap-btn" v-if="record.state === 'waiting_annotate' || record.state === 'doing_annotation' || record.state === 'already_annotation' || record.state === 'merge'">
          <a @click="handleAllocateReset(record, index)">重新分配</a>
        </span>
      <!-- <span class="gap-btn">
           <a @click="handleAudit(record)">审核</a>
         </span>-->
      <!--<span class="gap-btn">
            <a :class="record.state === 'already_annotation'?'':'grey'" @click="record.state === 'already_annotation'?handleSubmit(record):''">任务提交</a>
          </span>-->
    </template>
  </a-table>
  <br>
  <a-pagination
    :current="page.pageNum"
    show-quick-jumper
    :pageSize="10"
    :total="total"
    :show-total="total => `共 ${total} 条`"
    @change="getData"
  ></a-pagination>
  <AllocateDialog ref="allocateDialog" :current-item="currentItem" @refreshData="refreshHandle"></AllocateDialog>
  <SubAuditDialog ref="subAuditDialog" :current-item="currentItem"></SubAuditDialog>
  <sub-task-detail ref="subTaskDetail" :current-item="currentItem"></sub-task-detail>
</div>
</template>

<script>
import AllocateDialog from './AllocateDialog'
import { getDateTime, getTaskName, getValue, getSubStateName, getUserName } from '@/filters'
import SubAuditDialog from './SubAuditDialog'
import SubTaskDetail from '../TaskAllocation/SubTaskDetail'
import { getMyRelease, updateTask } from '@/api/task'
// import { getDataByPage } from '@/api/dataItem'
import { getDatasetItem } from '@/api/dataSet'

const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '说明',
    dataIndex: 'description'
  },
  {
    title: '状态',
    dataIndex: 'state',
    slots: { customRender: 'stateName' }
  },
  {
    title: '标注进度',
    dataIndex: 'progress',
    slots: { customRender: 'pgress' }
  },
  {
    title: '标注员',
    dataIndex: 'excuteUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

const data = [
  /* {
      id: 1,
      name: '任务1',
      type: '目标检测',
      description: '说明内容',
      time: '2020-10-15 20:00:00',
      demandTime: '2020-10-20 20:00:00',
      state: '已拒绝',
      people: 'name1',
      progress: '0/246'
    },
    {
      id: 2,
      name: '任务2',
      type: '目标检测',
      description: '说明内容',
      time: '2020-10-15 20:00:00',
      demandTime: '2020-10-20 20:00:00',
      state: '已审核',
      people: 'name1',
      progress: '0/246'
    },
    {
      id: 3,
      name: '任务3',
      type: '目标检测',
      description: '说明内容',
      time: '2020-10-15 20:00:00',
      demandTime: '2020-10-20 20:00:00',
      state: '标注中',
      people: 'name1',
      progress: '0/246'
    } */
]
export default {
  components: {
    // SearchOutlined,
    AllocateDialog,
    SubAuditDialog,
    SubTaskDetail
  },
  data () {
    return {
      form: {
        state: '',
        count: 5000,
        filterText: ''
      },
      tableData: data,
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentItem: {},
      addition: '',
      totalTaskNumber: '', // 总任务量
      taskNum: 0 // 单个任务量
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    getDateTime,
    getTaskName,
    getSubStateName,
    getUserName,
    getValue,
    getData (pageNum) {
      const parentId = this.$route.query.parentId
      if (pageNum) this.page.pageNum = pageNum
      getMyRelease({ ...this.page, parentId: parentId, field: 'name', order: 'asc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    refreshHandle (data) {
      // this.getData(1)
    },
    // 获取任务总量
    getDataItems (item, index, str) {
    //  const addition = this.addition
      getDatasetItem({
        datasetId: item.datasetId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(res => {
      //  const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
        this.totalTaskNumber = res.total
        if (this.totalTaskNumber % this.total === 0) {
          this.taskNum = this.totalTaskNumber / this.total
        } else {
          const ys = Math.floor(this.totalTaskNumber / this.total)
          if (index + 1 === this.total) {
            this.taskNum = this.totalTaskNumber - (this.total - 1) * ys
          } else {
            this.taskNum = ys
          }
        }
        this.currentItem = item
        if (str === 'detail') {
          this.$refs.subTaskDetail.open()
        } else {
          this.$refs.allocateDialog.open()
        }
      })
      /* getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.totalTaskNumber = data.total
        if (this.totalTaskNumber % this.total === 0) {
          this.taskNum = this.totalTaskNumber / this.total
        } else {
          const ys = Math.floor(this.totalTaskNumber / this.total)
          if (index + 1 === this.total) {
            this.taskNum = this.totalTaskNumber - (this.total - 1) * ys
          } else {
            this.taskNum = ys
          }
        }
        this.currentItem = item
        if (str === 'detail') {
          this.$refs.subTaskDetail.open()
        } else {
          this.$refs.allocateDialog.open()
        }
      }) */
    },
    // 分配
    handleAllocate (item, index) {
      // this.getDataItems(item, index, 'set')
      this.currentItem = item
      this.$refs.allocateDialog.open()
    },
    handleAllocateReset (item, index) {
      this.$confirm({
        title: '任务重置',
        content: '确认重新分配任务？此操作将清空之前的标注结果',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.currentItem = item
          this.currentItem.reset = true
          this.$refs.allocateDialog.open()
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    toDetail (item, index) {
      this.currentItem = item
      this.$refs.subTaskDetail.open()
    },
    // 审核
    handleAudit (item) {
      this.currentItem = item
      this.$refs.subAuditDialog.open()
    },
    // 提交
    handleSubmit (item) {
      this.$confirm({
        title: '任务提交',
        content: '确认任务已完成，并提交？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id, state: 'under_check'
          }).then(res => {
            this.$message.success('操作成功')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
